export const TOOLTIP_DIR_TYPE = {
  LEFT: 'left',
  RIGHT: 'right',
  TOP: 'top',
  BOTTOM: 'bottom',
  LEFTBOTTOM: 'leftBottom',
} as const;

export type TOOLTIP_DIR_TYPE_KEY = keyof typeof TOOLTIP_DIR_TYPE;
export type TOOLTIP_DIR_TYPE_VALUE =
  typeof TOOLTIP_DIR_TYPE[TOOLTIP_DIR_TYPE_KEY];
